// extracted by mini-css-extract-plugin
export var amountInputOverride = "pages-account-__PurchaseCharlieCardStoreForm-module___amountInputOverride";
export var buttonsOverride = "pages-account-__PurchaseCharlieCardStoreForm-module___buttonsOverride";